import React, { Component } from "react";

import { FaSortAlphaDown, FaSortAlphaUp } from "react-icons/fa";
import { MdFilterList } from "react-icons/md";
import { debounce } from "lodash";

import { MdMenu, MdInfo } from "react-icons/md";

import COLORS from "scss/colors.module.scss";
import FONTS from "scss/fonts.module.scss";
import { getHeaderIcon } from "../helpers/getHeaderIcon";
import ColumnSearch from "./ColumnSearch";
import styled from "styled-components";
import { IconButton } from "@material-ui/core";
import { StyledTooltip } from "../../../../common/utils/StyledTooltip";

export default class ColHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      availableSortings: ["", "asc", "desc"],
      sortingIndex: 0,
      filterApplied: false,
      isChecked: false,
      isSearchShown: false,
      isHeaderNameOverFlowed: false,
      open: false,
      isHeaderIconsDisabled: true,
    };

    props.column.addEventListener("sortChanged", this.onSortChanged.bind(this));
    props.column.addEventListener("filterChanged", this.onFilterChanged.bind(this));
    props.column.addEventListener(
      "menuVisibleChanged",
      this.onMenuVisibleChanged.bind(this)
    );
    // this.onSortRequested = this.onSortRequested.bind(this);
    this.headerNameRef = React.createRef();
  }

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  componentDidMount() {
    this.onSortChanged();
    this.onFilterChanged();
  }

  componentDidUpdate() {
    if (this.headerNameRef && this.headerNameRef.current) {
      setTimeout(() => {
        let headerOverFlow =
          this.headerNameRef?.current?.scrollWidth >
          this.headerNameRef?.current?.clientWidth;
        if (
          typeof headerOverFlow !== "undefined" &&
          headerOverFlow !== this.state.isHeaderNameOverFlowed
        ) {
          this.setState({ isHeaderNameOverFlowed: headerOverFlow });
        }
      }, 1);
    }
  }

  handleSearchChange = debounce((searchText) => {
    let options = this.props?.column?.colDef?.cellRendererParams;
    let value = searchText;
    if (this.props.column.colDef.store.isLazyLoadEnabled && this.props?.column?.colDef?.cellRendererParams?.columnTypeId == "22") {
      let decimals = String(value).includes(".") ? String(value).split(".")[1].length : 0;
      value = Number(value / 100).toFixed(decimals + 2);
    }
    if (this.props.column.colDef.filter === "agNumberColumnFilter") {
      this.getFilterInstance().setModel({
        type: "equals",
        filter: value
      });
      this.props.api.onFilterChanged();
      return;
    }
    // if (
    //   options &&
    //   options.columnTypeId &&
    //   String(value).includes(".") &&
    //   String(value).split(".")[1].length !== 0
    // ) {
    //   if (options.columnTypeId == 22) {
    //     let decimals = String(value).includes(".") ? String(value).split(".")[1].length : 2;
    //     value = isNaN(value) ? value : (Number(value) / 100).toFixed(decimals + 2);
    //   } else if (
    //     !isNaN(value) &&
    //     options.columnTypeId == 10 &&
    //     options.columnOptions?.column_type == "percentage"
    //   ) {
    //     let decimals = String(value).includes(".") ? String(value).split(".")[1].length : 2;
    //     value = (Number(value) / 100).toFixed(decimals + 2);
    //   }
    // }
    this.getFilterInstance().onFloatingFilterChanged(value);
  }, 500)

  getFilterInstance = () => {
    return this.props.api.getFilterInstance(this.props.column.colId);
  }

  getMenu() {
    let isIdColumn =
      this.props.column?.colDef?.store?.view?.type == "table" &&
      this.props.column?.colDef?.store?.view?.list_id &&
      this.props.column?.colDef?.store?.view?.options?.main_list_id &&
      this.props.column?.colDef?.store?.view?.list_id !=
        this.props.column?.colDef?.store?.view?.options?.main_list_id &&
      this.props?.displayName == "Id" &&
      this.props.column?.colDef?.store?.isLazyLoadEnabled;

    if (this.props.column.colDef?.cellRendererParams?.enableMenu && !this.state.isHeaderIconsDisabled) {
      return (
        <React.Fragment>
          {this.props.displayName !== "Parent Row Id" && this.props.displayName !== "Notes/Comments" && (
            <React.Fragment>
              <ColumnSearch
                onSearchTextChange={this.handleSearchChange}
                defaultValue={this.getFilterInstance().searchText}
                onColumnSearchClosed={() => {
                  if (this.state.isHeaderIconsDisabled === false) {
                    this.setState({ isHeaderIconsDisabled: true });
                  }
                }}
              />
              {this.props.displayName !== "Id" && this.props.column.colDef?.cellRendererParams?.columnTypeId != "9" && (
                <StyledIconButton
                  size="small"
                  ref={(filterMenuButton) => {
                    this.filterMenuButton = filterMenuButton;
                  }}
                  onClick={this.onFilterMenuClicked}
                >
                  <MdFilterList
                    size={FONTS.MEDIUM_SIZE_ICONS}
                    color={
                      this.state.filterApplied ||
                      (this.props.column.colDef.store.getViewCriteria() &&
                        this.props.column.colDef.store
                          .getViewCriteria()
                          .match(
                            new RegExp(
                              this.props.column.colDef.aliasPath + " ",
                              "g"
                            )
                          ))
                        ? COLORS.THEME_COLOR
                        : COLORS.TEXT_COLOR
                    }
                  />
                </StyledIconButton>
              )}
            </React.Fragment>
          )}
        {!isIdColumn && (
          <StyledIconButton
            size="small"
            ref={(menuButton) => {
              this.menuButton = menuButton;
            }}
            onClick={this.onMenuClicked}
          >
            <MdMenu className="headerMenuIcon" size={FONTS.MEDIUM_SIZE_ICONS} />
          </StyledIconButton>
        )}
        </React.Fragment>
      );
    }
    return null;
  }

  onMenuClicked = (e) => {
    this.props.showColumnMenu(this.menuButton);
    this.props.context.props.store.addColumnStore.setAnchorEl(this.addColumnMenuButton);
  };

  onFilterMenuClicked = (e) => {
    this.props.column.colDef.menuTabs = ["filterMenuTab"];
    this.props.showColumnMenu(this.filterMenuButton);
    this.props.context.props.store.addColumnStore.setAnchorEl(this.filterMenuButton);
    this.props.column.colDef.menuTabs = ["generalMenuTab","filterMenuTab"];
  };

  onSortChanged() {
    this.setState({
      sortingIndex: this.props.column.isSortAscending()
        ? 1
        : this.props.column.isSortDescending()
          ? 2
          : !this.props.column.isSortAscending() &&
            !this.props.column.isSortDescending()
            ? 0
            : 0,
    });
  }

  onFilterChanged() {
    this.setState({ filterApplied: this.props.column.filterActive })
  }

  onMenuVisibleChanged() {
    this.setState({
      isHeaderIconsDisabled: !this.props.column.menuVisible,
    });
  }

  clickedHeader = (e) => {
    this.props.api.clearRangeSelection();
    var minIndex = window.selectedColumnMinIndex !== undefined ? window.selectedColumnMinIndex : 0,
      maxIndex = window.selectedColumnMaxIndex !== undefined ? window.selectedColumnMaxIndex : 0,
      columns = [];

    this.props.columnApi.columnController.allDisplayedColumns.map((column, index) => {
      if (this.props.column.colId === column.colId) {
        if ((minIndex === 0 && maxIndex === 0) || !e.shiftKey) {
          minIndex = index;
          maxIndex = index;
        }
        else {
          if (index <= minIndex) {
            minIndex = index;
            maxIndex = maxIndex;
          }
          else {
            minIndex = minIndex;
            maxIndex = index;
          }
        }
      }
    })

    if (e.shiftKey) {
      for (let i = minIndex; i <= maxIndex; i++) {
        columns.push(this.props.columnApi.columnController.allDisplayedColumns[i]);
      }
    }
    else {
      columns.push(this.props.column)
    }

    this.props.api.addCellRange({
      columns: columns,
    });

    window.selectedColumnMinIndex = minIndex;
    window.selectedColumnMaxIndex = maxIndex;

  };

  componentWillUnmount() {
    window.selectedColumnMinIndex = undefined;
    window.selectedColumnMaxIndex = undefined;

    // var element = document.querySelector('[aria-label="filter"]');
    // if (element)
    // element.removeEventListener("mousedown", this.modifyFilterList)
  }

  handleChange() {
    let parentDOM = document.getElementById(
      this.props.column.colDef.store.gridId
    );
    let array = Array.from(parentDOM.getElementsByClassName("rowIdSelection"));
    if (!this.state.isChecked) {
      if (this.props?.column?.colDef?.store?.isLazyLoadEnabled) {
        const { currentRowsCount } = this.props.column.colDef.store;
        this.props.api.forEachNode(function (node, nodeIndex) {
          if (node.data.row_id != "" && node.data.row_id != "+") {
            node.selectThisNode(true);
          }
        });
        let recordsSelected = this.props.api.getSelectedNodes().length - this.props.column.colDef.store.noOfRecordsSelected;
        if (currentRowsCount > 1000 && recordsSelected <= 1000) {
          window.appStore.notificationStore.showNotification(
            "The top 1000 records will be selected. Please scroll more to select the other records.",
            "info"
          );
        }
      } else {
        this.props.api.selectAllFiltered();
      }
      this.props.column.colDef.store.addSelectedRecordsCount(
        this.props.api.getSelectedNodes().length -
          this.props.column.colDef.store.noOfRecordsSelected
          );
      // var selectedNodes = this.props.api.getSelectedNodes();
      // selectedNodes.map((node) => {
      //   if (node.data.row_id == "+") {
      //     node.setSelected(false);
      //   }
      // });
      array.map((item) => {
        if (
          !item.id.includes("unique_") &&
          this.props.column.colDef.store.isLazyLoadEnabled
        ) {
          item.checked = true;
        } else if (this.props.column.colDef.store.shouldLoadAllRows) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      });
    } else {
      this.props.api.deselectAll();
      this.props.column.colDef.store.resetSelectedRecordsCount();
      array.map((item) => {
        item.checked = false;
      });
    }

    this.setState({ isChecked: !this.state.isChecked });
  }

  render() {
    return (
      <StyledTooltip
        title={this.props.displayName}
        disableHoverListener={!this.state.isHeaderNameOverFlowed}
        open={this.state.open && this.state.isHeaderNameOverFlowed}
        onClose={this.handleClose}
        onOpen={this.handleOpen}
      >
        <div
        ref={(addColumnMenuButton) => {
              this.addColumnMenuButton = addColumnMenuButton;
            }}
          className="d-flex colHeaderContainer"
          style={{
            alignItems: "center",
            height: 40,
            width: this.props.column.colDef?.width
            ? this.props.column.colDef.width
            : (this.props.displayName === "Created By" ? 160 : 120),
          }}
          onMouseEnter={() => {
            if (this.state.isHeaderIconsDisabled === true) {
              this.setState({ isHeaderIconsDisabled: false });
            }
          }}
          onMouseLeave={() => {
            if (
              !this.props.column.menuVisible &&
              this.state.isHeaderIconsDisabled === false
            ) {
              this.setState({ isHeaderIconsDisabled: true });
            }
          }}
        >
          {this.props.displayName === "Id" && (
            <>
              <StyledDiv></StyledDiv>
              <div
                className="checkboxContainerMDB"
                onClick={(e) => {
                  this.handleChange();
                }}
              >
                <div className="custom-control custom-checkbox header-checkbox">
                  <input
                    ref="input"
                    type="checkbox"
                    className="custom-control-input"
                    id="defaultChecked"
                    onChange={() => {}}
                    checked={this.state.isChecked}
                  />
                  <label className="custom-control-label checkbox-pointer"></label>
                </div>
              </div>
            </>
          )}
          <div
            style={{
              height: 40,
              marginLeft: 3,
              display: "flex",
              width: this.props.column.colDef?.width
                ? this.props.displayName === "Actions" ||
                this.state.isHeaderIconsDisabled
                  ? this.props.column.colDef.width - 20
                  : this.props.displayName === "Parent Row Id"
                  ? this.props.column.colDef.width - 50
                  : this.props.displayName === "Id"
                  ? this.props.column.colDef.width - 100
                  : this.props.displayName === "Notes/Comments"
                  ? this.props.column.colDef.width - 60
                  : this.props.column.colDef?.cellRendererParams
                  ?.columnTypeId === "9"
                  ? this.props.column.colDef.width > 90
                  ? this.props.column.colDef.width - 90
                  : 0
                  : this.props.column.colDef.width > 110
                  ? this.props.column.colDef.width - 110
                  : 0
                : 120,
              justifyContent:
                this.props.displayName === "Actions" ? "center" : "unset",
            }}
            onClick={this.clickedHeader}
          >
            <StyledSpan ref={this.headerNameRef} color={
                  this.state.filterApplied ||
                  (this.props.column.colDef.store.getViewCriteria() &&
                    this.props.column.colDef.store
                      .getViewCriteria()
                      .match(
                        new RegExp(
                          this.props.column.colDef.aliasPath + " ",
                          "g"
                        )
                      ))
                    ? COLORS.THEME_COLOR
                    : COLORS.TEXT_COLOR
                } className="customHeaderLabel">
              {this.props.displayName}
              {(this.props?.column?.colDef?.cellRendererParams?.columnOptions?.is_mandatory && !this.props?.column?.colDef?.store?.isSubsheet) && <StyledSup> * </StyledSup>}
            </StyledSpan>
            <span style={{ display: "inline-block", alignSelf: "center" }}>
              {this.state.sortingIndex === 1 && (
                <FaSortAlphaDown
                  size={FONTS.MEDIUM_SIZE_ICONS}
                  color={COLORS.THEME_COLOR}
                  style={styles.icon}
                />
              )}
              {this.state.sortingIndex === 2 && (
                <FaSortAlphaUp
                  size={FONTS.MEDIUM_SIZE_ICONS}
                  color={COLORS.THEME_COLOR}
                  style={styles.icon}
                />
              )}
            </span>
          </div>
          {this.getMenu()}
        </div>
      </StyledTooltip>
    );
  }
}

const styles = {
  icon: {
    marginLeft: 5,
  },
};

const StyledIconButton = styled(IconButton)`
  cursor: default !important;
`;

const StyledDiv = styled.div`
  height: 24px;
  border-radius: 5px;
  align-self: center;
  margin-right: 3px;
`;

const StyledSpan = styled.span`
  color : ${props => props.color}
`;

const StyledSup = styled.sup`
  font-size: 13px;
  font-weight: 500;
  top: -1px;
`;